import Icon from "@react-native-vector-icons/material-design-icons/static";
import { Button, Card, IconButton, List } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import CardContainer from "../CardContainer";
import TooltipWrapper from "../TooltipWrapper";

type LegacyTestListItemData = {
	title: string;
	description: string;
	numericId: number;
	id: string;
};

type Props = {
	title: string;
	subtitle: string;
	list: LegacyTestListItemData[];
	appFont: string;
	handleDownload: (numericId: number) => void;
	onViewMore?: () => void;
	downloadingId?: number;
};

const DEFAULT_VISIBLE_ITEMS = 4;

export const LegacyTestsCard = ({
	title,
	subtitle,
	list,
	appFont,
	handleDownload,
	onViewMore,
	downloadingId,
}: Props) => {
	const theme = useAppTheme();

	const visibleItems = onViewMore ? list.slice(0, DEFAULT_VISIBLE_ITEMS) : list;
	const showViewMore =
		onViewMore !== undefined && list.length > DEFAULT_VISIBLE_ITEMS;

	return (
		<CardContainer
			title={title}
			subtitle={subtitle}
			icon="clipboard-text-outline"
		>
			<Card.Content
				style={{ paddingTop: 0, paddingBottom: 8, paddingHorizontal: 0 }}
			>
				{visibleItems.map((item) => (
					<List.Item
						key={item.id}
						disabled={item.numericId === downloadingId}
						onPress={() => handleDownload(item.numericId)}
						title={item.title}
						description={item.description}
						titleNumberOfLines={2}
						descriptionNumberOfLines={1}
						style={{
							paddingLeft: 16,
							paddingRight: 8,
						}}
						titleStyle={{
							fontFamily: `${appFont}-semibold`,
							fontSize: 14,
							lineHeight: 20,
						}}
						descriptionStyle={{
							fontSize: 12,
							lineHeight: 18,
							color: theme.colors.onSurfaceVariant,
						}}
						left={(props) => (
							<List.Icon
								{...props}
								style={{
									marginLeft: 0,
									marginRight: 12,
									alignSelf: "center",
								}}
								icon={() => (
									<Icon
										name="clipboard-text-outline"
										size={28}
										color={theme.colors.onSurfaceVariant}
									/>
								)}
							/>
						)}
						right={() => (
							<TooltipWrapper title="Download this legacy score report for offline review">
								<IconButton
									icon="download-outline"
									size={22}
									iconColor={theme.colors.onSurfaceVariant}
									accessibilityLabel={`Download ${item.title} as PDF`}
									loading={item.numericId === downloadingId}
									disabled={item.numericId === downloadingId}
									onPress={(event) => {
										event.stopPropagation();
										handleDownload(item.numericId);
									}}
								/>
							</TooltipWrapper>
						)}
					/>
				))}
			</Card.Content>
			{showViewMore ? (
				<Card.Actions>
					<Button mode="text" onPress={onViewMore}>
						View all ({list.length})
					</Button>
				</Card.Actions>
			) : null}
		</CardContainer>
	);
};
